import {getElement} from "./helpers.js";

const header = document.querySelector("header");
const footer = document.querySelector('footer');
const productPage = document.querySelector('.page__product-item');
const filterElement = getElement(".filter")
export { header, footer, productPage, filterElement };
